import script from "./AccessLog.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessLog.vue?vue&type=script&setup=true&lang=js"

import "./AccessLog.vue?vue&type=style&index=0&id=52e93f8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52e93f8c"]])

export default __exports__